export default __webpack_public_path__ + "static/media/light-violet-comments.320334ed.svg";